import { createAction } from 'redux-act';
import isEmpty from 'lodash/isEmpty';
import { getHomeData } from '../../../api/home';
import { leagueMatchId } from '../../../service/links';
import {
  isLiveMatchFinished,
  liveMatchId,
  unwrapMatchPayload,
  isMatchLive,
} from '../../../service/liveMatch';

export const showTips = createAction('show tips from home page');

export const homeShowTips = (state) => async (dispatch) => {
  dispatch(showTips({ state }));
};

// ----------------------GET DATA FROM BACKEND-------------------------------

export const getHomeInitialData = createAction(
  'get initial data for home page'
);
export const homeInitialDataLoading = createAction(
  'set loading state for loaded data'
);
export const homeGetHomeInitialData = () => async (dispatch) => {
  dispatch(homeInitialDataLoading());
  const response1 = await getHomeData();
  if (response1?.status !== 200) {
    return;
  }
  try {
    let {
      last_match,
      next_match,
      symbol,
      teamName,
      ranking,
      current_cup_ranking,
      current_season_ranking,
      best_cup_ranking,
      best_season_ranking,
      players_avg_rating,
      leagueName,
      timezone,
      inServer,
      teamId,
      cash_summary: { current_cash } = {},
      discordChannel,
      matchRunning,
      opponentTeamPremium,
      teamKit,
      opponentKit,
    } = await response1.json();
    current_cash = Math.round(current_cash);
    let learning = null;
    if (
      !isEmpty(last_match?.away_learnings) ||
      !isEmpty(last_match?.home_learnings)
    ) {
      learning = {
        awayLearnings: last_match.away_learnings,
        homeLearnings: last_match.home_learnings,
      };
    }
    dispatch(
      getHomeInitialData({
        rankingTable: ranking,
        last_match,
        next_match,
        current_cash,
        learning,
        symbol,
        teamName,
        current_cup_ranking,
        current_season_ranking,
        best_cup_ranking,
        best_season_ranking,
        players_avg_rating,
        leagueName,
        timezone,
        inServer,
        teamId,
        discordChannel,
        matchRunning,
        opponentTeamPremium,
        teamKit,
        opponentKit,
      })
    );
  } catch {
    return;
  }
};

export const liveMatchUpdated = createAction('Live match score updated');
export const liveMatchEnded = createAction('Live match ended');

/** Consecutive live-endpoint 404s with no home/strategy matchRunning before we clear. */
let live404EndStrikes = 0;

export const pollLiveMatch = (id) => async (dispatch, getState) => {
  if (!id) return;
  let response;
  try {
    response = await fetch(leagueMatchId + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      credentials: 'include',
    });
  } catch {
    return;
  }
  const listedAsLive = () => {
    const state = getState();
    return (
      isMatchLive(state?.home?.data?.matchRunning) ||
      isMatchLive(state?.team?.strategy?.matchRunning)
    );
  };
  const confirmMatchEnded = async ({ requireStrikes = false } = {}) => {
    try {
      await dispatch(homeGetHomeInitialData());
      if (isMatchLive(getState()?.home?.data?.matchRunning)) {
        live404EndStrikes = 0;
        return;
      }
      const { teamRefreshLiveMatch } = await import('../Team');
      await dispatch(teamRefreshLiveMatch());
      if (listedAsLive()) {
        live404EndStrikes = 0;
        return;
      }
      // Live endpoint 404s for the whole match — don't clear on one empty home/strategy read
      // (halftime / brief API gaps). Need two strikes in a row.
      if (requireStrikes) {
        live404EndStrikes += 1;
        if (live404EndStrikes < 2) return;
      }
      live404EndStrikes = 0;
      dispatch(liveMatchEnded());
    } catch {
      return;
    }
  };
  if (response.status === 200) {
    let data;
    try {
      data = await response.json();
    } catch {
      return;
    }
    const match = unwrapMatchPayload(data);
    if (isLiveMatchFinished(match)) {
      await confirmMatchEnded();
      return;
    }
    live404EndStrikes = 0;
    dispatch(liveMatchUpdated(match));
    return;
  }
  if (response.status === 404) {
    await confirmMatchEnded({ requireStrikes: true });
    return;
  }
  const running = getState()?.home?.data?.matchRunning;
  if (liveMatchId(running) && response.status >= 500) {
    return;
  }
};
